import React, { useEffect } from 'react';
import useBundleTranslation from 'i18n';
import { Box, FormControl } from '@mui/material';

import FormText from 'components/common/form/layout/control/FormText';
import { FormControlTextProps } from 'components/common/form/layout/control';
import { formatUrl } from './helpers';

import styles from './ExternalReportCustomUrl.styles';
import FormTextarea from 'components/common/form/layout/control/FormTextarea';
import { prepareFormElementProps } from 'components/common/form/formTools';
import ReactHookFormController from 'components/common/form/layout/ReactHookFormController';
import { ExternalReportCustomUrlControlProps } from 'app/editor/element/extreport/ExternalReportCustomUrl';

interface IProps {
    customAppend: string;
    append: string;
    generatedUrl: string;
    templateName?: string;
    appendFromSetting: string;
    controlProps: ExternalReportCustomUrlControlProps;
    // onChange: (nextValue: string) => void;
    formattedUrl: string;
}

const CustomUrlForm: React.FC<IProps> = ({
    controlProps,
    // onChange,
    customAppend,
    generatedUrl,
    append,
    templateName,
    appendFromSetting,
    formattedUrl,
}) => {
    const { t } = useBundleTranslation(['app/editor/element/extreport']);

    const form = controlProps.form;
    // const controlProps2: FormControlTextProps = {
    //     form,
    //     name: 'custom_append',
    //     onChange: () => {},
    //     // onChange,
    //     label: t('custom_append'),
    //     value: customAppend,
    // };
    //

    useEffect(() => {
        form.hookFormSetValue('custom_append', customAppend);
    }, [customAppend]);

    const fullUrlControlProps: FormControlTextProps = {
        form,
        name: 'full_url',
        onChange: () => {},
        label: t('full_url'),
        value: formatUrl(formattedUrl),
        disabled: true,
    };

    const appendOnSettingsControlProps: FormControlTextProps = {
        form,
        name: 'appended_base_on_setting',
        onChange: () => {},
        label: t('appended_base_on_setting'),
        value: appendFromSetting,
        disabled: true,
    };

    const appendFromControlProps: FormControlTextProps = {
        form,
        name: 'append_from',
        onChange: () => {},
        label: t('append_from'),
        value: append,
        disabled: true,
    };

    const generalUrlControlProps: FormControlTextProps = {
        form,
        name: 'generated_from',
        onChange: () => {},
        label: t('generated_from'),
        value: generatedUrl,
        disabled: true,
    };

    return (
        <Box>
            <Box sx={styles.textField} flexDirection="column">
                <FormControl fullWidth>
                    <FormText controlProps={generalUrlControlProps} />
                </FormControl>
                <Box sx={{ mt: 0.5 }}>
                    ({t('generated_from')}&nbsp;
                    <a target="_blank" href="/editor/plugin-url-template">
                        {templateName}
                    </a>
                    )
                </Box>
            </Box>
            <Box sx={styles.textField} flexDirection="column">
                <FormControl fullWidth>
                    <ReactHookFormController
                        elementProps={prepareFormElementProps({
                            ...controlProps,
                            component: {
                                component: 'FormText',
                                name: 'custom_append',
                                label: t('custom_append'),
                            },
                        })}
                    />
                </FormControl>
            </Box>

            {append && (
                <Box sx={styles.textField} flexDirection="column">
                    <FormControl fullWidth>
                        <FormText controlProps={appendFromControlProps} />
                    </FormControl>
                </Box>
            )}

            {appendFromSetting && (
                <Box sx={styles.textField} flexDirection="column">
                    <FormControl fullWidth>
                        <FormText controlProps={appendOnSettingsControlProps} />
                    </FormControl>
                </Box>
            )}

            <Box sx={styles.textField} flexDirection="column">
                <Box component="span" sx={styles.label}>
                    {t('full_url')}
                </Box>
                <FormControl fullWidth>
                    <FormTextarea controlProps={fullUrlControlProps} />
                </FormControl>
            </Box>
        </Box>
    );
};

export default CustomUrlForm;
